(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/password-recovery/components/password-recovery-form.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/password-recovery/components/password-recovery-form.js');
"use strict";


const MobileInput = svs.ui.reactFormInputs.MobileInput;
const {
  Form,
  RadioGroup,
  RadioButton
} = svs.ui.reactForm;
const Button = svs.ui.ReactButton;
const {
  MOBILE_LABEL,
  MOBILE_NAME
} = svs.ticket_partner.passwordRecovery.constants.FORMS.MOBILE;
const {
  RESTORE_OPTION_HEADER,
  RESTORE_OPTIONS
} = svs.ticket_partner.passwordRecovery.constants.FORMS;
const {
  showErrorDialog,
  showSuccessDialog
} = svs.ticket_partner.utils;
const {
  recoverPassword,
  passwordRecoveryErrorMapper
} = svs.ticket_partner.services;
const {
  useState
} = React;
const PasswordRecoveryForm = _ref => {
  let {
    email,
    restoreOptions,
    onRecoveySuccess
  } = _ref;
  const [mobile, setMobile] = useState('');
  const [restoreOption, setRestoreOption] = useState(restoreOptions[0] || '');
  const restoreOptionToText = restoreOption => {
    if (restoreOption === RESTORE_OPTIONS.SMS.value) {
      return RESTORE_OPTIONS.SMS.text;
    }
    if (restoreOption === RESTORE_OPTIONS.LETTER.value) {
      return RESTORE_OPTIONS.LETTER.text;
    }
    return '';
  };
  const handlePasswordRecoverySubmit = async (e, formData) => {
    e.preventDefault();
    if (_.values(formData).some(_ref2 => {
      let {
        isValid
      } = _ref2;
      return !isValid;
    })) {
      return;
    }
    try {
      await recoverPassword({
        deliveryChannel: restoreOption,
        userName: email,
        cellPhone: mobile
      });
      showSuccessDialog("Vi har nu skickat ditt l\xF6senord via ".concat(restoreOptionToText(restoreOption), "."), 'Lösenord skickat', () => {
        setRestoreOption('');
        setMobile('');
        onRecoveySuccess();
      });
    } catch (error) {
      showErrorDialog(passwordRecoveryErrorMapper(error));
    }
  };
  return React.createElement(Form, {
    onSubmit: handlePasswordRecoverySubmit
  }, React.createElement("h1", {
    className: "f-bold"
  }, RESTORE_OPTION_HEADER), React.createElement(RadioGroup, {
    size: "200"
  }, React.createElement(RadioButton, {
    checked: restoreOption === RESTORE_OPTIONS.SMS.value,
    disabled: !restoreOptions.includes(RESTORE_OPTIONS.SMS.value),
    label: RESTORE_OPTIONS.SMS.label,
    onChange: setRestoreOption,
    value: RESTORE_OPTIONS.SMS.value
  }), React.createElement(RadioButton, {
    checked: restoreOption === RESTORE_OPTIONS.LETTER.value,
    disabled: !restoreOptions.includes(RESTORE_OPTIONS.LETTER.value),
    label: RESTORE_OPTIONS.LETTER.label,
    onChange: setRestoreOption,
    value: RESTORE_OPTIONS.LETTER.value
  })), restoreOption === 'TextMessage' ? React.createElement(MobileInput, {
    label: MOBILE_LABEL,
    name: MOBILE_NAME,
    onChange: e => setMobile(e.target.value),
    value: mobile
  }) : null, React.createElement("div", {
    className: "u-flex u-flex-justify-content-center u-flex-align-items-center margin-3"
  }, React.createElement(Button, {
    inverted: true,
    type: "submit"
  }, "Forts\xE4tt")));
};
svs.ticket_partner.passwordRecovery.PasswordRecoveryForm = PasswordRecoveryForm;

 })(window);